import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CTAButton } from './ui/CTAButton';
export function MidPageCTA() {
  return <section id="precio" className="relative py-28 md:py-32 px-4 overflow-hidden" data-id="element-183">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-184">
        <img src="https://cdn.magicpatterns.com/uploads/uB9ZY93CBEJB5usPDQ2AUv/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-185" />
        <div className="absolute inset-0 bg-white/80" data-id="element-186"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-188">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-4" data-id="element-189">
            Transforma tu vida hoy
          </h2>
          <p className="text-xl text-[#5F6368] max-w-2xl mx-auto leading-relaxed" data-id="element-190">
            Todo lo que necesitas para comenzar tu camino hacia el bienestar
            emocional.
          </p>
        </motion.div>

        {/* Promotional Price Banner */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="mb-10" data-id="element-191">
          <div className="inline-flex flex-col items-center bg-[#F7F3E9] rounded-3xl shadow-[0_10px_30px_rgba(47,58,61,0.08)] border border-[#E8E1D5] px-10 py-10 md:px-16 md:py-12 relative overflow-hidden" data-id="element-192">
            {/* Inner subtle glow */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-white/60 to-transparent pointer-events-none" data-id="element-193"></div>

            {/* Badge */}
            <div className="relative z-10 flex items-center gap-2 bg-gradient-to-r from-[#F4A261] to-[#FFD166] text-white text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-6 shadow-md shadow-[#F4A261]/20" data-id="element-194">
              <SparklesIcon className="w-4 h-4" data-id="element-195" />
              <span data-id="element-196">Precio promocional</span>
            </div>

            {/* Price */}
            <div className="relative z-10 flex items-baseline gap-1 mb-3" data-id="element-197">
              <span className="text-6xl md:text-7xl font-bold text-[#2F3A3D] font-serif tracking-tight" data-id="element-198">
                $6
              </span>
              <span className="text-4xl md:text-5xl font-bold text-[#2F3A3D] font-serif" data-id="element-199">
                .39
              </span>
            </div>

            <p className="relative z-10 text-[#5F6368] text-base font-medium mb-8" data-id="element-200">
              Acceso inmediato · Descarga digital
            </p>

            {/* CTA Button */}
            <div className="relative z-10 w-full sm:w-auto" data-id="element-201">
              <CTAButton href="/upsell" onClick={trackAddToCart} className="w-full sm:w-auto" data-id="element-202">
                Compra ahora
              </CTAButton>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}